/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

// Polyfills

import 'core-js/es6/symbol';
import 'core-js/es6/object';
import 'core-js/es6/function';
import 'core-js/es6/parse-int';
import 'core-js/es6/parse-float';
import 'core-js/es6/number';
import 'core-js/es6/math';
import 'core-js/es6/string';
import 'core-js/es6/date';
import 'core-js/es6/array';
import 'core-js/es6/regexp';
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/weak-map';
import 'core-js/es6/weak-set';
import 'core-js/es6/typed';
import 'core-js/es6/reflect';
import 'core-js/es7/object';

import 'zone.js';
import 'ts-helpers';
import '@babel/polyfill';


// DOM polyfills below (mainly for IE/Edge)
import 'classlist-polyfill';
import 'compose-dataset-shim';

// closest + matches
// require('element-closest');

(function (ELEMENT: any) {
  ELEMENT.matches = ELEMENT.matches
    || ELEMENT.mozMatchesSelector
    || ELEMENT.msMatchesSelector
    || ELEMENT.oMatchesSelector
    || ELEMENT.webkitMatchesSelector;
  ELEMENT.closest = ELEMENT.closest || function closest(selector) {
    if (!this) {
      return null;
    }
    if (this.matches(selector)) {
      return this;
    }
    if (!this.parentElement) {
      return null;
    } else {
      return this.parentElement.closest(selector);
    }
  };
}(Element.prototype));

// localStorage
// require('localstorage-polyfill'); // TODO write fixture for window

// Node#contains
// Adapted from
// https://github.com/Financial-Times/polyfill-service/blob/master/polyfills/Node/prototype/contains/polyfill.js
(function (NodePrototype: any) {
  NodePrototype.contains = NodePrototype.contains || function contains(node: any) {
    if (!(0 in arguments)) {
      throw new TypeError('1 argument is required');
    }
    do {
      if (this === node) {
        return true;
      }
    } while (node = node && node.parentNode);

    return false;
  };
})(Node.prototype);

// Array#flatMap (stage 1 proposal : http://bterlson.github.io/proposal-flatMap/)
(function (ArrayPrototype: any) {
  if (ArrayPrototype.flatMap === undefined) {
    Object.defineProperty(Array.prototype, 'flatMap', {
      value: function (f: Function) {
        return this.reduce((ys: any, x: any) => {
          return ys.concat(f.call(this, x));
        }, []);
      },
      enumerable: false
    });
  }
})(Array.prototype);

if (![].includes) {
  Array.prototype.includes = function (searchElement/*, fromIndex*/) {
    'use strict';
    const O = Object(this);
    const len = parseInt(O.length, 10) || 0;
    if (len === 0) {
      return false;
    }
    const n = parseInt(arguments[1], 10) || 0;
    let k;
    if (n >= 0) {
      k = n;
    } else {
      k = len + n;
      if (k < 0) {
        k = 0;
      }
    }
    while (k < len) {
      const currentElement = O[k];
      if (searchElement === currentElement ||
        (searchElement !== searchElement && currentElement !== currentElement)
      ) {
        return true;
      }
      k++;
    }
    return false;
  };
}

if (!String.prototype.includes) {
  String.prototype.includes = function () {
    'use strict';
    return String.prototype.indexOf.apply(this, arguments) !== -1;
  };
}
